import {Grid, Link} from '@yandex-delivery/blocks'
import React, {useCallback, useState} from 'react'
import type {ContentDetailsItem} from 'src/api/types'
import arrowSrc from 'src/shared/assets/arrow.svg'
import infoSrc from 'src/shared/assets/info.svg'
import {isAuthMode} from 'src/shared/config'
import i18n from 'src/shared/i18n'

import {useIsMobile} from '../../hooks'
import {TextItem} from '../text-item'
import DetailsDesktop from './DetailsDesktop'
import DetailsMobile from './DetailsMobile'
import DetailsMobileAuth from './DetailsMobileAuth'
import {classes} from './styles'

type Props = {
  item: ContentDetailsItem
}

const Details: React.FC<Props> = ({item}) => {
  const [showDrawer, setShowDrawer] = useState(false)
  const setShown = useCallback(() => setShowDrawer(true), [])
  const setHidden = useCallback(() => setShowDrawer(false), [])

  const isMobile = useIsMobile()
  const DetailsModal = isMobile ? (isAuthMode ? DetailsMobileAuth : DetailsMobile) : DetailsDesktop

  return (
    <>
      <Grid
        alignItems="center"
        className={classes.root}
        component={Link}
        container
        data-details-link
        onClick={setShown}
        size="m"
        wrap="nowrap"
      >
        <Grid item>
          <img alt="" data-theme-invert loading="lazy" src={infoSrc} />
        </Grid>
        <Grid item xs>
          <TextItem item={item.title} />
          {item.subtitle && <TextItem item={item.subtitle} />}
        </Grid>
        <Grid item>
          <img
            alt=""
            className={classes.arrowIcon}
            data-e2e="openDetails"
            data-theme-invert
            loading="lazy"
            src={arrowSrc}
          />
        </Grid>
      </Grid>

      {showDrawer && (
        <DetailsModal
          classes={classes}
          onClose={setHidden}
          sections={item.sections}
          title={item.title?.text || i18n.print('route_order_details')}
        />
      )}
    </>
  )
}

export default Details
